var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"timeline"}},[_c('b-tabs',{attrs:{"nav-class":['timeline-tabs', { 'border-0': !_vm.showContent }],"content-class":{ 'd-none': !_vm.showContent }}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }